import { Checkbox, Col, Form, Input, Row, Tooltip } from 'antd';
import { useIntl } from 'react-intl';
import { FloatingFormItem, Group } from '@/components/_common';
import { QuestReportType } from '@/core/domain/questReport/Reports/WorkOrder/WorkOrder.types';
import ReportWorkOrderSyntheticCheckbox from './ReportWorkOrderSyntheticCheckbox';
import ReportWorkOrderOtherFields from './ReportWorkOrderOtherFields';
import ReportWorkOrderSyntheticGroupedCheckbox from './ReportWorkOrderSyntheticGroupedCheckbox';
import { Info } from 'react-feather';

const ReportWorkOrderOptionsFields: React.FC = () => {
  const intl = useIntl();

  const handleSyntheticCheckboxes = (
    isSyntheticGrouped: boolean,
    isSynthetic: boolean,
  ) => {
    return (
      <Group>
        {!isSyntheticGrouped && <ReportWorkOrderSyntheticCheckbox />}

        {!isSynthetic && <ReportWorkOrderSyntheticGroupedCheckbox />}
      </Group>
    );
  };

  return (
    <>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const reportType = getFieldValue('reportType');
          const isSynthetic = getFieldValue('isSynthetic');
          const isSyntheticGrouped = getFieldValue('isSyntheticGrouped');

          switch (reportType) {
            case QuestReportType.totalPerWorkOrder:
              return (
                <Col sm={24}>
                  <Row gutter={[12, 12]}>
                    <Col span={24}>
                      {handleSyntheticCheckboxes(
                        isSyntheticGrouped,
                        isSynthetic,
                      )}
                    </Col>

                    {!isSyntheticGrouped && (
                      <Col span={24} md={8}>
                        <Form.Item
                          noStyle
                          name="includeParticular"
                          initialValue={false}
                          valuePropName="checked"
                        >
                          <Checkbox>
                            {intl.formatMessage({
                              id: 'movementWorkOrdersReport.form.particular',
                            })}
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    )}

                    <Col span={24} md={16}>
                      <Group>
                        <Form.Item
                          name="IncludeCpf"
                          initialValue={false}
                          valuePropName="checked"
                          noStyle
                        >
                          <Checkbox>Gerar apenas com dados de CPF</Checkbox>
                        </Form.Item>

                        <Tooltip title="Exibe apenas os orçamentos relacionados a pessoas físicas (CPF).">
                          <Info size={20} cursor="pointer" />
                        </Tooltip>
                      </Group>
                    </Col>

                    {!isSyntheticGrouped && (
                      <Col span={24} md={8}>
                        <Form.Item
                          noStyle
                          name="includeInsurer"
                          initialValue={false}
                          valuePropName="checked"
                        >
                          <Checkbox>
                            {intl.formatMessage({
                              id: 'movementWorkOrdersReport.form.insurer',
                            })}
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    )}

                    <Col span={24} md={16}>
                      <Group>
                        <Form.Item
                          name="IncludeCnpj"
                          initialValue={false}
                          valuePropName="checked"
                          noStyle
                        >
                          <Checkbox>Gerar apenas com dados de CNPJ</Checkbox>
                        </Form.Item>

                        <Tooltip title="Exibe apenas os orçamentos relacionados a pessoas jurídicas (CNPJ).">
                          <Info size={20} cursor="pointer" />
                        </Tooltip>
                      </Group>
                    </Col>

                    {isSyntheticGrouped && (
                      <Col span={24}>
                        <Form.Item
                          noStyle
                          name="isDetailComplementsInReport"
                          initialValue={false}
                          valuePropName="checked"
                        >
                          <Checkbox>
                            Imprimir separadamente os complementos
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    )}
                  </Row>
                </Col>
              );

            case QuestReportType.estimators:
              return (
                <>
                  <Col sm={24}>
                    <ReportWorkOrderSyntheticCheckbox />
                  </Col>

                  {!isSyntheticGrouped && (
                    <Col span={24}>
                      <Form.Item
                        noStyle
                        name="includeParticular"
                        initialValue={false}
                        valuePropName="checked"
                      >
                        <Checkbox>
                          {intl.formatMessage({
                            id: 'movementWorkOrdersReport.form.particular',
                          })}
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  )}

                  {!isSyntheticGrouped && (
                    <Col span={24}>
                      <Form.Item
                        noStyle
                        name="includeInsurer"
                        initialValue={false}
                        valuePropName="checked"
                      >
                        <Checkbox>
                          {intl.formatMessage({
                            id: 'movementWorkOrdersReport.form.insurer',
                          })}
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  )}
                </>
              );

            case QuestReportType.workOrderCost:
              return (
                <>
                  <Col span={24}>
                    <Form.Item
                      noStyle
                      name="includeParticular"
                      initialValue={false}
                      valuePropName="checked"
                    >
                      <Checkbox>
                        {intl.formatMessage({
                          id: 'movementWorkOrdersReport.form.particular',
                        })}
                      </Checkbox>
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      noStyle
                      name="includeInsurer"
                      initialValue={false}
                      valuePropName="checked"
                    >
                      <Checkbox>
                        {intl.formatMessage({
                          id: 'movementWorkOrdersReport.form.insurer',
                        })}
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </>
              );

            case QuestReportType.servicesAndPartsPerVehicle:
              return (
                <Col span={24}>
                  <Row gutter={[12, 12]}>
                    <Col span={24}>
                      <ReportWorkOrderOtherFields />
                    </Col>

                    <Col sm={16}>
                      <FloatingFormItem
                        name="filterByPartAndService"
                        label={intl.formatMessage({
                          id: 'movementWorkOrdersReport.form.filterServiceAndPartDescription',
                        })}
                      >
                        <Input />
                      </FloatingFormItem>
                    </Col>
                  </Row>
                </Col>
              );

            case QuestReportType.workOrderPerArea:
              return (
                <>
                  <Col sm={24}>
                    <ReportWorkOrderSyntheticCheckbox />
                  </Col>

                  <Col sm={24}>
                    <ReportWorkOrderOtherFields />
                  </Col>
                </>
              );
            default:
              return null;
          }
        }}
      </Form.Item>
    </>
  );
};

export default ReportWorkOrderOptionsFields;
